import { useContext } from 'react';
import SchoolContext from '@/contexts/school';
import { axiosInstance as axios } from '@/plugins/axios';

const useAuth = () => {
  const { schema, slug } = useContext(SchoolContext);

  const endpoint = `${process.env.NEXT_PUBLIC_RESERVE_ENDPOINT}/api/v1/auth/attempt`;

  /**
   * Get number of login attempt and last attempt time
   * @param email
   * @returns
   */
  const getLoginAttempt = async (
    email: string,
  ): Promise<{ login_attempts: number; login_attempt_time: number; email: string | null }> => {
    const data = await axios.get(`${endpoint}?schema=${schema}&email=${encodeURIComponent(email)}&slug=${slug}`);
    return data.data;
  };

  /**
   * Increase number of login attempt when login failed
   * @param email
   * @returns
   */
  const loginFailed = async (email: string): Promise<any> => {
    const data = await axios.post(`${endpoint}?schema=${schema}&email=${encodeURIComponent(email)}&slug=${slug}`);
    return data.data;
  };
  /**
   * Reset login attempt when login success
   * @param accessToken
   * @returns
   */
  const loginSuccess = async (accessToken: string): Promise<any> => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

    const data = await axios.post(`${endpoint}/reset?schema=${schema}&slug=${slug}`);
    return data.data;
  };

  return { getLoginAttempt, loginFailed, loginSuccess };
};

export default useAuth;
